<template>
  <div class="p-4">
    <!-- Export All Loyalty -->
    <v2-base-button id="loyalty.export-all" v-if="$route.name != 'loyalty-enhanced-tiers' && !isFoodicsOnline" icon
      @click="exportAllLoyalty" :disabled="loading"
      class="flex items-center gap-2 bg-primary text-white px-4 py-2 rounded shadow">
      <i v-if="!loading" class="ni ni-cloud-download-95"></i>
      <svg v-else class="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
        viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
      </svg>
      {{ loading ? translate('EXPORTING...') : translate('EXPORT ALL LOYALTY') }}
    </v2-base-button>

    <!-- Tiers & Collections -->
    <router-view />
  </div>
</template>

<script>
import V2BaseButton from '@/components/V2/V2BaseButton.vue';
import { defineComponent } from 'vue';
import Translations from '@/mixins/translations';
import { Loyalty } from '@/services/SOLO';

export default defineComponent({
  name: 'SoloLoyalty',
  mixins: [Translations],
  components: {
    V2BaseButton,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    isFoodicsOnline() {
      return window.location.host.includes('foodics');
    },
  },
  methods: {
    exportAllLoyalty() {
      this.loading = true;
      var notify = this.$notify || (this.$root && this.$root.$notify);
      var translate = this.translate;
      if (typeof notify === 'function') {
        notify({
          title: translate('PLEASE WAIT!'),
          message: translate("We are working on the report. We will send the exported loyalty transactions link to your email."),
          type: 'success',
        });
      }
      Loyalty.exportAllLoyalty()
        .then(function (response) {
          this.loading = false;
          window.open(response.data.data.attributes['csv-uri'], '_blank');
        }.bind(this))
        .catch(function (err) {
          this.loading = false;
          var notify = this.$notify || (this.$root && this.$root.$notify);
          var translate = this.translate;
          var message = JSON.parse(err && err.response && err.response.data && err.response.data.messages)?.errors?.status?.[0]
            || JSON.parse(err && err.response && err.response.data && err.response.data.messages)?.message
            || translate('Something went wrong, please try again!');
          if (typeof notify === 'function') {
            notify({
              title: translate('SYSTEM ERROR!'),
              message: message,
              type: 'error',
            });
          }
        }.bind(this));
    },
  },
  created() {
    this.$root.$refs.SoloLoyalty = this;
  },
});
</script>
